export function init() {
    document.querySelectorAll("select").forEach((selectElement) => {
        const select = NiceSelect.bind(selectElement, {searchable: true});

        if(selectElement.options[0].selected == false) {
            select.dropdown.insertAdjacentHTML('afterend', `<button class='btn bg-transparent' data-action='clear'> <i class="text--2xs fa-regular fa-xmark"></i> </button>`)
            select.dropdown.nextSibling.onclick = function(event) {
                event.preventDefault()
                select.clear()
                select.dropdown.children[0].classList.add("custon-placeholder")
                selectElement.options[0].selected = true

                if (selectElement.options[0].selected == true) {
                    selectElement.nextSibling.offsetParent.querySelector("button").remove()
                    select.dropdown.classList.remove("active")
                }
            };
        } 
        
        select.dropdown.children[1].children[1].onclick = () => {
            select.dropdown.classList.add("active")
            select.dropdown.insertAdjacentHTML('afterend', `<button class='btn bg-transparent' data-action='clear'> <i class="text--2xs fa-regular fa-xmark"></i> </button>`)

            select.dropdown.nextSibling.onclick = function(event) {
                event.preventDefault()
                select.clear()
                select.dropdown.children[0].classList.add("custon-placeholder")
                selectElement.options[0].selected = true

                if (selectElement.options[0].selected == true) {
                    selectElement.nextSibling.offsetParent.querySelector("button").remove()
                    select.dropdown.classList.remove("active")
                }
            };
        }

        observeDOM(select.el, () => {
            select.update()
        });
    })
}

var observeDOM = (function() {
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

    return function( obj, callback ){
        if ( !obj || obj.nodeType !== 1 ) return;

        if ( MutationObserver ){
            var mutationObserver = new MutationObserver(callback)
            mutationObserver.observe( obj, { childList:true, subtree:true })
            return mutationObserver
        } else if ( window.addEventListener ){
            obj.addEventListener('DOMNodeInserted', callback, false)
            obj.addEventListener('DOMNodeRemoved', callback, false)
        }
    }
})()
